// extracted by mini-css-extract-plugin
export default {"label":"wastage__label___KJlwA","select":"wastage__select___N8PYk","fieldLabel":"wastage__fieldLabel___4vfYf"};